// @flow
const EmptyComponent = () => null

export default EmptyComponent
